import React from 'react';

import * as Styles from './styles';

const WARNING_ORANGE = '#ED8B1F';
const ICON_COLOR = '#4B4665';

const WarningMark = () => (
    <svg viewBox="0 0 48 48" fill="none" aria-hidden="true">
        <circle
            cx="24"
            cy="24"
            r="22"
            stroke={WARNING_ORANGE}
            strokeWidth="3"
        />
        <path
            d="M24 13V25"
            stroke={WARNING_ORANGE}
            strokeWidth="3.5"
            strokeLinecap="round"
        />
        <circle cx="24" cy="33.5" r="2.5" fill={WARNING_ORANGE} />
    </svg>
);

const ApartmentsIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path
            d="M4.5 20V5.5C4.5 4.95 4.95 4.5 5.5 4.5H13.5C14.05 4.5 14.5 4.95 14.5 5.5V20"
            stroke={ICON_COLOR}
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M14.5 10.5H18.5C19.05 10.5 19.5 10.95 19.5 11.5V20"
            stroke={ICON_COLOR}
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M7.5 8.5H8.5M10.5 8.5H11.5M7.5 11.5H8.5M10.5 11.5H11.5M7.5 14.5H8.5M10.5 14.5H11.5M16.5 14.5H17.5"
            stroke={ICON_COLOR}
            strokeWidth="1.8"
            strokeLinecap="round"
        />
        <path
            d="M9.5 20V17H11.5V20M3.5 20H20.5"
            stroke={ICON_COLOR}
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

const LandmarksIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path
            d="M12 21C12 21 18 15.6 18 10.2C18 6.78 15.31 4 12 4C8.69 4 6 6.78 6 10.2C6 15.6 12 21 12 21Z"
            stroke={ICON_COLOR}
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <circle cx="12" cy="10" r="2.2" stroke={ICON_COLOR} strokeWidth="1.8" />
        <path
            d="M3.5 20H20.5"
            stroke={ICON_COLOR}
            strokeWidth="1.8"
            strokeLinecap="round"
        />
    </svg>
);

const LocalShopsIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path
            d="M5 9.5L6.2 5.5H17.8L19 9.5"
            stroke={ICON_COLOR}
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M4.5 9.5H19.5V11C19.5 12.38 18.38 13.5 17 13.5C15.62 13.5 14.5 12.38 14.5 11C14.5 12.38 13.38 13.5 12 13.5C10.62 13.5 9.5 12.38 9.5 11C9.5 12.38 8.38 13.5 7 13.5C5.62 13.5 4.5 12.38 4.5 11V9.5Z"
            stroke={ICON_COLOR}
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M6 13.2V19.5H18V13.2M9 19.5V16.5H15V19.5"
            stroke={ICON_COLOR}
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

const HIGHLIGHTS = [
    { label: 'Apartments', icon: <ApartmentsIcon /> },
    { label: 'Landmarks', icon: <LandmarksIcon /> },
    { label: 'Local shops', icon: <LocalShopsIcon /> },
];

export default function AddressPrecisionWarning() {
    return (
        <Styles.Card role="status">
            <Styles.Header>
                <Styles.WarningBadge>
                    <WarningMark />
                </Styles.WarningBadge>
                <Styles.Copy>
                    We need a more precise location. Can you be more specific
                    and provide additional details such as:
                </Styles.Copy>
            </Styles.Header>
            <Styles.Highlights>
                {HIGHLIGHTS.map(({ label, icon }) => (
                    <Styles.Highlight key={label}>
                        <Styles.HighlightIcon>{icon}</Styles.HighlightIcon>
                        <span>{label}</span>
                    </Styles.Highlight>
                ))}
            </Styles.Highlights>
        </Styles.Card>
    );
}
